// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__QrWgR","statsImage":"Stats_statsImage__uskG7","edit":"Stats_edit__ApPkG","right":"Stats_right__baiMy"};